import React from 'react';
import { Outlet } from 'react-router';
import { AppProvider } from './AppContext';
import Header from './components/Header';
import Aside from './components/Aside';

const Layout: React.FC = () => {
  return (
    <AppProvider>
      <div className="bg-surface-bright text-on-surface font-body-md min-h-screen">
        <Header />
        <Aside />
        <main className="md:ml-64 pt-24 min-h-screen flex flex-col">
          <div className="px-4 md:px-margin-desktop  w-full mx-auto pb-8 flex-1">
            <Outlet />
          </div>
          {/* <Footer /> */}
        </main>
      </div>
    </AppProvider>
  );
};

export default Layout;
